import CircleBackgroundIcon from '@/atoms/icons/CircleBackground';
import Size from '@enums/Size';
import CloseIcon from '@mui/icons-material/CloseRounded';
import IconButton from './IconButton';

const CancelButton = ({ onClick }) => {
  return (
    <IconButton
      color="light-blue"
      fullWidth={false}
      onClick={onClick}
      size={Size.LARGE}
    >
      <CircleBackgroundIcon
        color="light-blue"
        size={Size.X_SMALL}
        icon={<CloseIcon />}
      />
    </IconButton>
  );
};

export default CancelButton;
